/**
 * @fileoverview react-i18next initialization.
 * @description Bundles the three supported locales statically and initializes the default
 * i18next singleton (not a scoped instance), so `useTranslation()` resolves real strings even in
 * tests that render a component without an explicit provider wrapper.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY } from '@/shared/lib/i18n/language.constants'
import en from '@/shared/lib/i18n/locales/en.json'
import hi from '@/shared/lib/i18n/locales/hi.json'
import mr from '@/shared/lib/i18n/locales/mr.json'

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      mr: { translation: mr },
    },
    supportedLngs: ['en', 'hi', 'mr'],
    load: 'languageOnly',
    fallbackLng: DEFAULT_LANGUAGE,
    initAsync: false,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  })

export { i18next }
